import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '@app/app.config.provider';
import {
  AccountCharacteristicConflict,
  AccountCharacteristicConflictNumber,
  AccountCharacteristicConflictRequest
} from '@models/import/account-characteristic';
import { IPollFileImport } from '@models/import/poll-file-import';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImportConflictsService {
  private apiUrl: string;

  /**
   * Caching of conflicts
   */
  private readonly conflicts: Map<string, AccountCharacteristicConflict[]> = new Map();

  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfigProvider) {
    this.appConfig.environment.subscribe(env => {
      this.apiUrl = `${env.API.REFERENCE_DATA}/api/import/conflicts`;
    });
  }

  public GetNumberOfConflicts(): Observable<AccountCharacteristicConflictNumber> {
    return this.http.get<AccountCharacteristicConflictNumber>(`${this.apiUrl}/number`);
  }

  public async GetConflicts(req?: AccountCharacteristicConflictRequest) {
    const key =
      req && req.PageNumber && req.PageSize ? `${req.PageNumber}-${req.PageSize}-${req.OnlyActive ? 'active' : 'all'}` : `default`;
    if (!this.conflicts.has(key)) {
      this.conflicts.set(key, await this.http.post<AccountCharacteristicConflict[]>(`${this.apiUrl}`, req || {}).toPromise());
    }

    return this.conflicts.get(key);
  }

  public updateConflicts() {
    return this.http.get<IPollFileImport>(`${this.apiUrl}/resolve`);
  }

  public clearCache() {
    this.conflicts.clear();
  }
}
